import Project from '../project';

/**
 * Create the action
 */

const { thunk, request, success, error } = Project.index((fetch) => {
    return fetch.get('/projects');
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
